import { render } from "./Gamemaster.vue?vue&type=template&id=738b1670&scoped=true"
import script from "./Gamemaster.vue?vue&type=script&lang=js"
export * from "./Gamemaster.vue?vue&type=script&lang=js"

import "./Gamemaster.vue?vue&type=style&index=0&id=738b1670&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/inclusion_score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738b1670"]])

export default __exports__